import { Box, Drawer } from '@mui/material'
import { useMediaQuery, useTheme } from '@mui/system'

import { UqRdmLogoColor } from '../../UqRdmLogoColor'
import { MenuDrawerLogoBar } from './LogoBar'
import { SkipMenu } from './SkipMenu'

type Props = {
  children: React.ReactNode | React.ReactNode[]
  forceTemporary?: boolean
  open: boolean
  onClose: () => void
}

export const BaseMenuDrawer = ({ children, forceTemporary = false, open, onClose }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const showBurgerMenu = isMobile || forceTemporary

  return (
    <Box component="nav" sx={showBurgerMenu ? {} : { width: { lg: 320 }, flexShrink: { lg: 0 } }}>
      <Drawer
        variant={showBurgerMenu ? 'temporary' : 'permanent'}
        open={showBurgerMenu ? open : true}
        onClose={showBurgerMenu ? onClose : undefined}
        sx={{
          display: showBurgerMenu
            ? { md: 'block', lg: 'block', xl: 'block' }
            : { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 340,
            borderRight: 0,
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <MenuDrawerLogoBar height={64} showCloseButton={showBurgerMenu} onClose={onClose} />
          <Box sx={{ borderRight: '1px solid rgba(0, 0, 0, 0.12)', flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ flex: 1 }}>
              <SkipMenu />
              {children}
            </Box>
            <Box sx={{ ml: 1 }}>
              <UqRdmLogoColor width={150} height={96} />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  )
}
